import { EditableImg, EditableText } from '@smartfire/components'
import { useTranslation } from 'react-i18next'
import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine'
import style from './block.module.scss'
import Inspector from './Inspector'
import useMediaQuery from '@mui/material/useMediaQuery'
import clsx from 'clsx'

const ItemProfile = ({ suggestions, complete, active, setActive, number }) => {
    const { isEditing } = useEditor()
    const { t } = useTranslation()
    useInspectorControl(Inspector)
    const tablet = useMediaQuery(`(max-width:${style.tabletBreakpoint})`)

    /**
     * Scroll to bottom of header to show automatically suggests (tablet and mobile)
     * update active item and disable if re-click on them
     */
    const handleClick = () => {
        if (tablet) {
            const containerHeader = document.getElementById('container_header')
            setTimeout(() => {
                containerHeader.scrollTo(0, containerHeader.scrollHeight)
            }, 100)
        }
        setActive((old) => (old === number ? null : number))
    }

    const itemClasses = clsx({
        [style.item]: true,
        [style.admin]: isEditing,
        [style.active]: active,
    })

    return (
        <BlockWrapper.Div className={itemClasses} onClick={handleClick}>
            <EditableImg smartProp={'icon'} className={style.icon} />
            <EditableText smartProp={'label'} className={style.label} />

            <div className={style.suggests} onClick={(e) => e.stopPropagation()}>
                <div className={style.head}>{t('Suggestions')} :</div>
                <div className={style.elements}>
                    {suggestions.map((suggest, index) => (
                        <a
                            key={index}
                            href={suggest.value}
                            dangerouslySetInnerHTML={{ __html: suggest.label }}
                        />
                    ))}
                </div>
                <div className={style.complete}>
                    <a href={complete}>+ {t('Voir la sélection complète')}</a>
                </div>
            </div>
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: ItemProfile,
    smartProps: {
        icon: smartProps.picto,
        label: smartProps.string.withDefault('Patients et proches'),
        suggestions: smartProps.array.withDefault([
            {
                label: '',
                value: '',
            },
        ]),
        complete: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Profile',
        parent: ['smartfire/header'],
    },
})
